import {Redirect} from "react-router-dom";
import {CssBaseline} from "@mui/material";
import ManagerRoutes from "@/Containers/ManagerRoutes";
import {ConfirmProvider} from "material-ui-confirm";
import Sidebar from "@/Components/Sidebar/Sidebar";
import {useSelector} from "react-redux";
import {selectMandant} from "@/Redux/App/AppReducer";
import Sidebar70447 from "@/Components/Sidebar/Sidebar70447";
import SidebarV2 from "@/Components/Sidebar/SidebarV2/SidebarV2";
import {
    MainComponentQueryRendererQueryResponse
} from "@/Containers/__generated__/MainComponentQueryRendererQuery.graphql";
import { useTranslationModeSwitch} from "@/Utils/CustomHooks/useTranslationModeSwitch";
import {useSidebarV2} from "@/Utils/FeatureFlags";
import {useEffect} from "react";
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";

interface ManagerComponentProps {
    isLoggedIn: boolean;
    viewData?: MainComponentQueryRendererQueryResponse;
    toggleComponents: () => void;
}

export default function ManagerComponent(props: ManagerComponentProps) {
    const mandant = useSelector((state) => selectMandant(state));

    const mode = useTranslationModeSwitch()
    console.log(props.viewData)

    useEffect(() => {
        if (props.isLoggedIn) {
            props.toggleComponents();
        }
    }, [mode, props.toggleComponents]);


    const sidebarV2Enabled = useSidebarV2();
    const {t} = useTranslation();

    const renderSidebar = () => {
        if (mandant.abasId == 70447) {
            return <Sidebar70447/>;
        }

        if (sidebarV2Enabled) {
            return <SidebarV2 viewData={props?.viewData} toggleComponents={props.toggleComponents} />
        }

        return <Sidebar/>;
    };

    if (!props.isLoggedIn) {
        return <Redirect to={"/login"}/>;
    }


    return (
        <>
            <CssBaseline/>
            <ConfirmProvider
                defaultOptions={{
                    title: null,
                    dialogProps: {
                        maxWidth: "sm",
                        fullWidth: true,
                        style: {
                            zIndex: 100000,
                        },
                    },
                    cancellationText: t("general.cancel"),
                    confirmationText: t("general.confirm"),
                    cancellationButtonProps: {
                        variant: "outlined",
                        size: "small",
                        color: "secondary",
                        style: {marginBottom: 10},
                        disableElevation: true,
                    },
                    confirmationButtonProps: {
                        variant: "contained",
                        size: "small",
                        style: {marginBottom: 10},
                        disableElevation: true,
                    },
                }}
            >
                {renderSidebar()}
                <ManagerRoutes/>
            </ConfirmProvider>
        </>
    );
}
